// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3OnCd","description":"PatientConsentPreview_description__NdCRT"};